import { render } from "./CalendarIcon.vue?vue&type=template&id=1d5e178a"
const script = {}

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__